import {observer} from "mobx-react";
import React,{Component} from "react";
import {dcUnitsStore, receptionBunkersStore, shipment, storageStore} from "../../../../stores";
import localStyles from "../index.css";

@observer
export default class Lines extends Component{

    graphDotsList = ['hopper','drying','cleaning','silo', 'output'];
    graphElementsBlock = [receptionBunkersStore.receptionBunker,storageStore.hoppersList,dcUnitsStore.dryingList, dcUnitsStore.cleaningList, storageStore.silosList];
    map = {'hopper':storageStore.hoppersList,'drying':dcUnitsStore.dryingList, 'cleaning': dcUnitsStore.cleaningList, 'silo':storageStore.silosList};

    findElem(list,type){
        let result = list.find((item)=>{
            return (item.status === 'clogged' && item.active && item.scenario.length && !!item.scenario[item.currentOperation] && item.scenario[item.currentOperation].type === type);
        });
        if(result) return result.status;
        result = list.find((item)=>{
            return (item.currentOperation > 0 && item.active && item.scenario.length && !!item.scenario[item.currentOperation] && item.scenario[item.currentOperation].type === type);
        });
        return (result ?  result.culture : null);
    }

    getLines(){
        let graphDotsList = this.graphDotsList;
        let graphElementsBlock = this.graphElementsBlock;
        let siloLines = [];
        let inheritColor = "None";
        let graph = [[0,0,0,0,0],[0,0,0,0,0],[0,0,0,0,0],[0,0,0,0,0],[0,0,0,0,0]];
        let wayList = [];
        let line = [0,0,0,0,0,0,0,0];

        graphElementsBlock.forEach((item,i)=>{
            graphDotsList.forEach((dots,j)=>{
                graph[i][j] = this.findElem(item,dots)
            })
        });

        graph.forEach((item,i)=>{
            item.forEach((elem,j)=>{
                if(elem){
                    wayList.push({
                        culture:elem,
                        out: i,
                        in:j,
                        length: (i - (j + 1))
                    })}
            })
        });

        wayList.sort((a,b) =>{
            if (b.culture === 'clogged') return 1;
            if (a.culture === 'clogged') return -1;
            let f = a.length < 0 ? a.length + 1 : a.length;
            let s = b.length < 0 ? b.length + 1 : b.length;
            return(Math.abs(f) - Math.abs(s))
        }).forEach((item,i)=>{
            if(item.length >=0){
                for (let j = item.out * 2-1; j >= item.out * 2 - Math.abs(item.length * 2) - 1; j--) {
                    if (!line[j]) line[j] = item.culture;
                }
            }else {
                for (let j = item.out * 2; j < item.out * 2 + Math.abs(item.length * 2) - 1; j++) {
                    if (!line[j]) line[j] = item.culture;
                }
            }
        });

        //getSiloLines
        let clogged = false;
        for(let i = 0; i<graph.length-1;i++){
            if (graph[i][graphDotsList.length-1] === 'clogged'){
                for (let j = 0; j < graphElementsBlock[4].length; j++) {
                    siloLines[j] = 'clogged';
                }
                clogged = true;
                break;
            }
        }

        if(!clogged){
            graph.forEach((item,i)=>{
                if(item[4] && i !== graph.length-1){inheritColor=item[4]}
            });
            if(line[7]) {
                for (let j = 0; j < graphElementsBlock[4].length; j++) {
                    siloLines[j] = 'clogged';
                }
                if (graphElementsBlock[4].status === 'clogged'){}
            }

        }else{
            inheritColor = 'clogged'
        }

        let map = this.map;
        let list = storageStore.silosList;
        let length = list.length -1;
        let baseline;
        let r,l,cr,cl, result =[], item;
        for(let i = 0; i<length+1;i++)result[i]=0
        r=l=cr=cl=0;
        for(let i=0;i <= length;i++){
            item = list[length - i];
            if(!!item.scenario[item.currentOperation]) {
                if (item.scenario[item.currentOperation].type === 'output') {
                    if(shipment.shipmentBunker[item.scenario[item.currentOperation].num].status === 'clogged'){
                        for(let j = length-cr; j>=length - i+1; j--){result[j] = 'clogged';baseline='clogged';}
                        cr=r=i;
                    }else{
                        for(let j = length - r; j>=length- i+1; j--){if(!result[j])result[j] = item.culture;
                            if(!baseline)baseline=item.culture;
                        }
                        r=i;
                    }
                }
            }
            item = list[i];
            if(!!item.scenario[item.currentOperation]) {
                if (item.scenario[item.currentOperation].type !== 'output') {
                    if(map[item.scenario[item.currentOperation].type][item.scenario[item.currentOperation].num].status === 'clogged'){
                        for(let j = cl; j<=i; j++){result[j] = 'clogged';}
                        cl=l=i+1;
                    }else{
                        for(let j = l; j<=i; j++)if(!result[j])result[j] = item.culture;
                        l=i+1;
                    }
                }
            }
            if((cl>length-cr) || l >length-r)break;
        }
        if(!baseline){baseline=inheritColor;};

        return (
            <div className={localStyles.lowerBus + ' ' + localStyles[baseline]}>
                {line.map((item,i)=>{
                    if(i) return (<div className={localStyles[item ? item : 'None']} key={i} />);
                    return null;
                })}
                {result.map((item,i)=>{
                    if(!i)return null;
                    return(
                        <div className={localStyles.siloToSilo + ' ' + localStyles[item ? item : inheritColor]} key={i}/>
                    )
                })}
            </div>
        );
    }

    render(){
        return(
            <div>
                {this.getLines()}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/shared/components/Game/ElevatorField/Lines/index.js